const extractIds = (arrayOfObjects) => {
  let arrayOfIds = [];
  arrayOfObjects.forEach((item) => {
    arrayOfIds.push(item.id);
  });
  return arrayOfIds;
};
export default extractIds;
